// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__Z5NEW","link":"styles_link__CmWF+"};